/**
 * Visual marker for `WorkItem.standalone = true`. Verbatim port of
 * the Next-side component — pill shape matches the GitLab type
 * pills (ISSUE / INCIDENT) so all three read as one badge family;
 * indigo avoids clashing with the GitLab `task` type (purple).
 */
type Props = {
  size?: "sm" | "xs";
  className?: string;
};

export function StandaloneBadge({ size = "sm", className = "" }: Props) {
  const dims = size === "xs" ? "px-1.5 py-0 text-[10px]" : "px-2 py-0.5 text-xs";
  return (
    <span
      data-testid="standalone-badge"
      className={`inline-flex items-center rounded-full border border-indigo-400 bg-indigo-100 font-medium text-indigo-800 dark:border-indigo-500/50 dark:bg-indigo-500/15 dark:text-indigo-200 ${dims} ${className}`}
    >
      TASK
    </span>
  );
}
